import React from 'react'
import PropTypes from 'prop-types'

const buttons = {
  add: 'icon-aytmfd-add-question',
  delete: 'icon-aytmfd-close'
}

const Button = props => {
  const onClick = () => {
    if (!props.wait && props.onClick) props.onClick({ action: props.action })
  }

  const className = props.wait ? `${props.className} ${props.className}-wait` : props.className

  return (
    <div className={className} onClick={onClick}>
      <i className={`${buttons[props.action]} ${props.className}-icon`}></i>
    </div>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  action: PropTypes.string,
  wait: PropTypes.any,
  onClick: PropTypes.func
}

export default Button
